/* eslint-disable no-template-curly-in-string */
import { yupToFormErrors } from 'formik';
import * as R from 'ramda';
import plural from 'system/libs/plural';
import Yup from 'yup';
import { setLocale } from 'yup/lib/customLocale';

import { NetworkValidationRules } from './NetworkValidationRules';
import { ValidationRules } from './ValidationRules';

setLocale({
    mixed: {
        required: 'Заполните поле',
        notType: ({ type }) =>
            type === 'number' ? 'Введите число' : 'Некорректное значение',
    },
    string: {
        max: ({ max }) =>
            `Максимум ${max} ${plural(max, ['символ', 'символа', 'символов'])}`,
        min: ({ min }) =>
            `Минимум ${min} ${plural(min, ['символ', 'символа', 'символов'])}`,
        email: 'Введите валидный email',
    },
    number: {
        max: 'Максимальное значение - ${max}',
        min: 'Минимальное значение - ${min}',
        integer: 'Введите целое число',
    },
});

const createSchema = <T extends {}>(yupObject: Partial<Record<keyof T, any>>) =>
    Yup.object().shape(R.filter<any>(R.identity, yupObject));

function validateYupSchemaSync(data, schema, context = {}) {
    const validateData = Object.entries(data).reduce((acc, [key, value]) => {
        acc[key] = value === '' ? undefined : value;
        return acc;
    }, {});

    return schema.validateSync(validateData, {
        abortEarly: false,
        context,
    });
}

const validateSchema = ({ values, validationSchema }) => {
    const schema =
        typeof validationSchema === 'function'
            ? validationSchema()
            : validationSchema;
    try {
        validateYupSchemaSync(values, schema);
        return {};
    } catch (error) {
        return yupToFormErrors(error);
    }
};

const validateSchemaAndQuotaErrors = ({
    values,
    validationSchema,
    quotaErrors,
}) => {
    const { common, ...fieldErrors } = quotaErrors;

    const errors = validateSchema({
        values,
        validationSchema,
    });

    if (common) {
        // @ts-ignore
        errors.common = common;
    }

    return {
        ...errors,
        ...fieldErrors,
    };
};

export const Validation = {
    ...ValidationRules,
    ...NetworkValidationRules,
    createSchema,
    validateYupSchemaSync,
    validateSchema,
    validateSchemaAndQuotaErrors,
    Yup,
};
